import React from 'react';
import { Helmet } from 'react-helmet';
const TrackingScripts = () => {
  return <Helmet data-id="element-1272" data-mp="34uh9inguanzt">
      {/* Zoho PageSense */}
      <script src="https://cdn.pagesense.io/js/j0utkoxe/e06a1ff2f072445ebf200ca380c4cef5.js" data-id="element-1273" data-mp="34tfw4cccppex"></script>
      {/* HubSpot Embed Code */}
      <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/22826617.js" data-id="element-1274" data-mp="39rzkejef3dag"></script>
      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-KRVY4DXVM8" data-id="element-1275" data-mp="2h3bta76zltoz"></script>
      <script data-id="element-1276" data-mp="2q5us8g7njm5y">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          // Força a página a aparecer como /app/analise-ux/
          gtag('config', 'G-KRVY4DXVM8', {
            'page_path': '/app/analise-ux/'
          });
        `}
      </script>
    </Helmet>;
};
export default TrackingScripts;